// Dữ liệu mẫu Services Map (board Mint-ServicesMap v486: S0 + LTS, Supabase 24/Oct/2026). Sinh bằng script từ board, không sửa tay.
// TODO: thay bằng TblServiceRoute / _Carrier / _Point / _Vessel qua DataSource khi A-07 có route.
import type { BoardService } from './svcmap';

export const BOARD_SERVICES: readonly BoardService[] = [
  {
    "code": "KHS1",
    "name": "Korea Ho Chi Minh Service",
    "grp": "nea",
    "carriers": "EMC HAL KMT SKR",
    "rotation": "THBKK THLCH VNSGN KRPUS KRUSN KRKAN VNSGN THLCH THBKK",
    "circ": 21,
    "vn": "VNSGN",
    "main": "KRPUS",
    "tt": 7,
    "last": "03/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "N · S",
    "link": "kmtc.co.kr › schedule"
  },
  {
    "code": "KCS",
    "name": "Korea China Straits Service",
    "grp": "nea",
    "carriers": "IAL KMT NSS ONE PIL",
    "rotation": "SGSIN MYPKG VNSGN CNSHK KRPUS KRINC CNTAO CNSHA SGSIN",
    "circ": 28,
    "vn": "VNSGN",
    "main": "KRPUS",
    "tt": 7,
    "last": "27/Dec/2026",
    "locked": true,
    "active": true,
    "bound": "N · S",
    "link": "one-line.com › long term"
  },
  {
    "code": "KCI",
    "name": "Korea China Indonesia Service",
    "grp": "nea",
    "carriers": "CKL CNC HMM PIL",
    "rotation": "IDCGK IDSRG VNSGN KRPUS KRINC CNSHA CNNGB IDCGK",
    "circ": 21,
    "vn": "VNSGN",
    "main": "KRPUS",
    "tt": 5,
    "last": "07/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "N · S",
    "link": ""
  },
  {
    "code": "NKT",
    "name": "New Korea Thailand",
    "grp": "nea",
    "carriers": "CKL CNC KMT NSS",
    "rotation": "THBKK THLCH VNSGN KRINC KRKAN KRPUS HKHKG CNSHK THLCH THBKK",
    "circ": 21,
    "vn": "VNSGN",
    "main": "KRPUS",
    "tt": 8,
    "last": "27/Nov/2026",
    "locked": true,
    "active": true,
    "bound": "N · S",
    "link": ""
  },
  {
    "code": "CKI",
    "name": "China Korea Indonesia Service",
    "grp": "nea",
    "carriers": "COS KMT ONE",
    "rotation": "VNSGN CNSHA KRPUS KRKAN CNSHA CNNGB IDCGK IDSUB VNSGN",
    "circ": 21,
    "vn": "VNSGN",
    "main": "KRPUS",
    "tt": 8,
    "last": "20/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "N · S",
    "link": ""
  },
  {
    "code": "IA12",
    "name": "Shanghai-Ho Chi Minh Service 2",
    "grp": "nea",
    "carriers": "CNC MSK",
    "rotation": "VNSGN CNSHA VNSGN",
    "circ": 14,
    "vn": "VNSGN",
    "main": "CNSHA",
    "tt": 8,
    "last": "01/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "N · S",
    "link": "maersk.com › schedules"
  },
  {
    "code": "CTS",
    "name": "China Thailand Service",
    "grp": "nea",
    "carriers": "OOL YML ZIM",
    "rotation": "VNSGN THLCH HKHKG CNSHA CNNGB CNXMN VNSGN",
    "circ": 21,
    "vn": "VNSGN",
    "main": "CNSHA",
    "tt": 11,
    "last": "10/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "N · S",
    "link": ""
  },
  {
    "code": "CTX",
    "name": "China-Thailand-Vietnam Express",
    "grp": "nea",
    "carriers": "JJS ZIM",
    "rotation": "THBKK THLCH VNSGN CNSHA CNXMN THLCH THBKK",
    "circ": 21,
    "vn": "VNSGN",
    "main": "CNSHA",
    "tt": 7,
    "last": "26/Oct/2026",
    "locked": true,
    "active": true,
    "bound": "N · S",
    "link": ""
  },
  {
    "code": "VTX3",
    "name": "Vietnam-Thailand-Japan-China Service",
    "grp": "nea",
    "carriers": "KMT SIT",
    "rotation": "THLCH VNSGN CNSHK JPNGO JPTYO JPKWS JPYOK CNSHA CNWNZ THLCH",
    "circ": 28,
    "vn": "VNSGN",
    "main": "JPTYO",
    "tt": 10,
    "last": "29/Nov/2026",
    "locked": false,
    "active": true,
    "bound": "N · S",
    "link": "sitc.com › schedule"
  },
  {
    "code": "JTVS",
    "name": "Japan-Chu Lai-Vietnam Service",
    "grp": "nea",
    "carriers": "CNC",
    "rotation": "VNDAD THLCH VNSGN JPTYO JPYOK JPNGO JPUKB KRPUS KRKAN TWKHH VNDAD",
    "circ": 28,
    "vn": "VNSGN",
    "main": "JPTYO",
    "tt": 7,
    "last": "07/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "N · S",
    "link": ""
  },
  {
    "code": "TSE",
    "name": "Taiwan-South East Asia Service",
    "grp": "nea",
    "carriers": "YML",
    "rotation": "SGSIN MYPKG VNSGN VNDAD VNHPH HKHKG TWKHH TWTXG TWKHH HKHKG VNHPH VNDAD VNSGN SGSIN",
    "circ": 28,
    "vn": "VNSGN",
    "main": "TWKHH",
    "tt": 6,
    "last": "31/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "N · S",
    "link": ""
  },
  {
    "code": "VTS1",
    "name": "Vietnam Thailand Service",
    "grp": "sea",
    "carriers": "CKL DJS HAL HMM KMT SKR",
    "rotation": "THBKK THLCH HKHKG CNXMN KRPUS KRKAN HKHKG VNSGN THLCH THBKK",
    "circ": 21,
    "vn": "VNSGN",
    "main": "THLCH",
    "tt": 2,
    "last": "07/Dec/2026",
    "locked": false,
    "active": false,
    "bound": "N · S",
    "link": ""
  },
  {
    "code": "TE2",
    "name": "Thailand Vietnam East India 2",
    "grp": "isc",
    "carriers": "COS EMC IAL ONE RCL WHL YML",
    "rotation": "INVTZ MYPKG SGSIN VNSGN THLCH SGSIN MYPKG INMAA INVTZ",
    "circ": 28,
    "vn": "VNSGN",
    "main": "INMAA",
    "tt": 12,
    "last": "17/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "E · W",
    "link": ""
  },
  {
    "code": "AEU7",
    "name": "Asia-Europe Service 7",
    "grp": "eu",
    "carriers": "CMA COS EMC OOL",
    "rotation": "GBFXT MYPKG CNSHA CNXMN HKHKG CNYTN VNVUT SGSIN NLRTM DEHAM BEZEE GBFXT",
    "circ": 91,
    "vn": "VNVUT",
    "main": "NLRTM",
    "tt": 33,
    "last": "02/Dec/2026",
    "locked": true,
    "active": true,
    "bound": "E · W",
    "link": "oocl.com › long term"
  },
  {
    "code": "MEX",
    "name": "Mediterranean Club Express",
    "grp": "eu",
    "carriers": "CMA COS EMC OOL",
    "rotation": "ESVLC ESBCN FRFOS MTMLA MYPKG CNTAO CNSHA CNNGB CNXMN CNNSA CNSHK VNVUT SGSIN MTMLA ESVLC",
    "circ": 91,
    "vn": "VNVUT",
    "main": "MTMLA",
    "tt": 22,
    "last": "04/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "E · W",
    "link": "cma-cgm.com › line services"
  },
  {
    "code": "EC3",
    "name": "US East Coast 3",
    "grp": "am",
    "carriers": "HMM ONE YML",
    "rotation": "CNTXG CNTAO KRPUS THLCH VNVUT SGSIN LKCMB USNYC USJAX USSAV USCHS CUMZO MXZLO CNTXG",
    "circ": 84,
    "vn": "VNVUT",
    "main": "USNYC",
    "tt": 34,
    "last": "08/Feb/2027",
    "locked": true,
    "active": true,
    "bound": "E · W",
    "link": ""
  },
  {
    "code": "PEX3",
    "name": "Pacific Express 3",
    "grp": "am",
    "carriers": "CMA COS EMC",
    "rotation": "SGSIN VNVUT CNSHK CNNGB CNSHA KRPUS USHOU USMOB USMIA SGSIN",
    "circ": 70,
    "vn": "VNVUT",
    "main": "USHOU",
    "tt": 32,
    "last": "06/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "E · W",
    "link": ""
  },
  {
    "code": "PE1",
    "name": "Pendulum Express 1",
    "grp": "am",
    "carriers": "CMA COS EMC OOL",
    "rotation": "VNHPH VNSGN CNSHA CLLSQ USOAK TWKHH CNSHK VNHPH",
    "circ": 63,
    "vn": "VNSGN",
    "main": "USOAK",
    "tt": 24,
    "last": "03/Jan/2027",
    "locked": true,
    "active": true,
    "bound": "E · W",
    "link": ""
  }
];

/** Lịch dài hạn tại cảng VN, tuần W43–W51: '' = blank sailing · '-' = chưa có dữ liệu · '>' = hết lịch đã nhập · 'tàu chuyến|ETD|cờ'. */
export const BOARD_LTS: Readonly<Record<string, readonly string[]>> = {
  "KHS1": [
    "SAWASDEE INCHEON 2611N|21/Oct|d4",
    "KMTC BANGKOK 2612N|29/Oct|+HEUNG-A HOCHIMINH 2612N 30/Oct",
    "SAWASDEE INCHEON 2612N|05/Nov",
    "HEUNG-A HOCHIMINH 2613N|14/Nov|+KMTC BANGKOK 2613N 15/Nov",
    "",
    "SAWASDEE INCHEON 2613N|26/Nov",
    "KMTC BANGKOK 2614N|06/Dec",
    "HEUNG-A HOCHIMINH 2614N|13/Dec",
    "SAWASDEE INCHEON 2614N|17/Dec"
  ],
  "KCS": [
    "NYK ISABEL 0186N|21/Oct|d5",
    "",
    "KOTA GAYA 0433N|08/Nov",
    "STARSHIP MERCURY 2609N|10/Nov",
    "LOS ANDES BRIDGE 0247N|18/Nov|+KMTC PENANG 2609N 20/Nov",
    "",
    "KOTA GAYA 0434N|05/Dec|+STARSHIP MERCURY 2610N 05/Dec",
    "KMTC PENANG 2610N|09/Dec",
    "LOS ANDES BRIDGE 0248N|16/Dec"
  ],
  "KCI": [
    "-",
    "SKY PRIDE 2608N|26/Oct|+HUI ZHOU JIN HAI KI8070N89 28/Oct",
    "KOTA NASRAT 0215N|04/Nov",
    "CNC PANTHER KI80B0N89|11/Nov",
    "SKY PRIDE 2609N|19/Nov",
    "HUI ZHOU JIN HAI KI80F0N89|25/Nov|+CNC PANTHER KI80L0N89 29/Nov",
    "",
    "SKY PRIDE KI80N0N89|11/Dec",
    "HUI ZHOU JIN HAI KI80P0N89|15/Dec"
  ],
  "NKT": [
    "SKY CHALLENGE 2611N|24/Oct",
    "KMTC NAGOYA 2612N|27/Oct|+STARSHIP AQUILA 2612N 01/Nov",
    "",
    "SKY CHALLENGE 2612N|10/Nov|+KMTC NAGOYA 2613N 13/Nov",
    "STARSHIP AQUILA 2613N|19/Nov",
    "SKY CHALLENGE 2613N|27/Nov",
    ">",
    ">",
    ">"
  ],
  "CKI": [
    "KMTC HAIPHONG 2608N|25/Oct|c",
    "",
    "",
    "KMTC SHANGHAI 2609N|12/Nov",
    "KMTC INCHEON 2610N|19/Nov",
    "KMTC HAIPHONG 2609N|25/Nov",
    "",
    "KMTC SHANGHAI 2610N|10/Dec",
    "KMTC INCHEON 2611N|17/Dec"
  ],
  "IA12": [
    "AMALFI BAY 0HO4LN1NC|23/Oct|d4",
    "SHIMANAMI BAY 0HO4NN1NC|26/Oct|+AMALFI BAY 0HO4PN1NC 01/Nov",
    "SHIMANAMI BAY CV8010N89|06/Nov",
    "AMALFI BAY CV8030N89|12/Nov",
    "SHIMANAMI BAY CV8050N89|17/Nov",
    "AMALFI BAY CV8070N89|23/Nov|+SHIMANAMI BAY CV8090N89 28/Nov",
    "AMALFI BAY CV80B0N89|04/Dec",
    "SHIMANAMI BAY CV80D0N89|11/Dec",
    "AMALFI BAY CV80F0N89|18/Dec"
  ],
  "CTS": [
    "-",
    "GSL AFRICA 103N|28/Oct|+BUXMELODY 248N 29/Oct",
    "YM CREDENTIAL 111N|02/Nov",
    "GSL AFRICA 104N|15/Nov",
    "BUXMELODY 249N|17/Nov|+YM CREDENTIAL 112N 22/Nov",
    "",
    "GSL AFRICA 105N|02/Dec|+BUXMELODY 250N 06/Dec",
    "YM CREDENTIAL 113N|13/Dec",
    "GSL AFRICA 106N|20/Dec"
  ],
  "CTX": [
    "INFINITY 2640N|23/Oct|d6",
    "XIN AN 73N|26/Oct",
    ">",
    ">",
    ">",
    ">",
    ">",
    ">",
    ">"
  ],
  "VTX3": [
    "SITC KANTO 2625N|20/Oct|d1",
    "SITC WENDE 2623N|01/Nov",
    "SITC CHANGDE 2623N|08/Nov",
    "SITC FUJIAN 2627N|15/Nov",
    "SITC SHENGDE 2625N|22/Nov",
    "SITC WENDE 2625N|29/Nov",
    ">",
    ">",
    ">"
  ],
  "JTVS": [
    "CNC BANGKOK JTV050N89|21/Oct|d7",
    "CNC SULAWESI JTV070N89|28/Oct|+CA SAIGON JTV090N89 29/Oct",
    "ASL HONG KONG JTV0B0N89|05/Nov",
    "CNC BANGKOK JTV0D0N89|12/Nov",
    "CNC SULAWESI JTV0F0N89|19/Nov",
    "CA SAIGON JTV0H0N89|26/Nov",
    "ASL HONG KONG JTV0J0N89|02/Dec",
    "CNC BANGKOK JTV0L0N89|10/Dec",
    "CNC SULAWESI JTV0N0N89|17/Dec"
  ],
  "TSE": [
    "YM INSTRUCTION 348S|23/Oct|d6",
    "YM INSTRUCTION 348N|27/Oct",
    "ANBIEN BAY 2610N|03/Nov",
    "YM HORIZON 420N|10/Nov",
    "YM HARMONY 441N|17/Nov",
    "YM INSTRUCTION 349N|24/Nov",
    "ANBIEN BAY 2611N|01/Dec",
    "YM HORIZON 421N|08/Dec",
    "YM HARMONY 442N|15/Dec"
  ],
  "VTS1": [
    "SAWASDEE VEGA 2613S|24/Oct|c",
    "-",
    "-",
    "-",
    "-",
    "-",
    "-",
    "-",
    "-"
  ],
  "TE2": [
    "-",
    "ZHONG GU XIONG AN 012W|27/Oct",
    "WAN HAI 317 W248|04/Nov|+RACHA BHUM 215W 08/Nov",
    "EVER BRAVE 106W|15/Nov",
    "ZHONG GU XIONG AN 013W|22/Nov",
    "WAN HAI 317 W249|29/Nov",
    "RACHA BHUM 216W|06/Dec",
    "EVER BRAVE 107W|13/Dec",
    "ZHONG GU XIONG AN 014W|20/Dec"
  ],
  "AEU7": [
    "COSCO DENMARK 070W|22/Oct|d2",
    "CSCL ATLANTIC OCEAN 067W|28/Oct",
    "CSCL STAR 093W|04/Nov",
    "COSCO SHIPPING PLANET 049W|11/Nov",
    "OOCL JAPAN 041W|18/Nov",
    "",
    "CSCL GLOBE 077W|02/Dec",
    ">",
    ">"
  ],
  "MEX": [
    "APL VANDA 0MEOXW1MA|21/Oct|d3",
    "",
    "CMA CGM BOUGAINVILLE MEX020W19|02/Nov",
    "CMA CGM JULES VERNE MEX040W19|09/Nov",
    "CMA CGM GEORG FORSTER MEX080W19|16/Nov",
    "CMA CGM TRITON MEX0A0W19|23/Nov",
    "CMA CGM VASCO DE GAMA MEX0C0W19|30/Nov",
    "CMA CGM TOLLA MEX0E0W19|07/Dec",
    "CMA CGM ALEXANDER VON H MEX0G0W19|14/Dec"
  ],
  "EC3": [
    "ONE BLUE JAY 043E|23/Oct|d7",
    "HMM GARNET 011E|28/Oct",
    "ONE AQUILA 033E|06/Nov",
    "HMM RUBY 015E|10/Nov",
    "ONE APUS 024E|17/Nov",
    "ONE MADRID 031E|24/Nov|+ONE MONACO 032E 29/Nov",
    "",
    "ONE SUMMIT 002E|12/Dec",
    "ONE FALCON 034E|16/Dec"
  ],
  "PEX3": [
    "CMA CGM LITANI PX30C0E19|23/Oct|d2",
    "BELITA PX30E0E19|01/Nov",
    "",
    "CMA CGM OHIO PX30G0E19|10/Nov|+KOI PX30I0E19 11/Nov",
    "CMA CGM FIDELIO PX30K0E19|18/Nov",
    "CMA CGM NIAGARA PX30M0E19|25/Nov",
    "CMA CGM ORFEO PX30O0E19|02/Dec",
    "CMA CGM ATTILA PX30Q0E19|09/Dec",
    "CMA CGM TIGRIS PX30S0E19|16/Dec"
  ],
  "PE1": [
    "-",
    "COSCO ENGLAND MTE0E0E19|31/Oct|+ERVING MTE0G0E19 01/Nov",
    "CMA CGM AMAZON MTE0I0E19|08/Nov",
    "",
    "CMA CGM JEAN GABRIEL MTE0K0E19|18/Nov|+CMA CGM MEMPHIS MTE0M0E19 22/Nov",
    "",
    "CMA CGM LYRA MTE0O0E19|02/Dec|+APL DANUBE MTE0S0E19 06/Dec",
    "APL DUBLIN MTE0U0E19|13/Dec",
    "CMA CGM LA TRAVIATA MTE0W0E19|20/Dec"
  ]
};
